import React from 'react';

const Error500Svg = () => (
  <svg
    width="562px"
    height="200px"
    viewBox="0 0 562 200"
    version="1.1"
    style={{
      maxWidth: '100%'
    }}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="✏️-Feilmeldinger-–-404,-500"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="interoptik-500"
        transform="translate(-439.000000, -238.000000)"
        fill="#D8ECEC"
      >
        <g id="Group-3" transform="translate(439.000000, 238.000000)">
          <g id="Group">
            <path
              d="M459.380928,82.4891422 C536.304808,82.4891422 561.943004,91.2157535 561.943004,141.243633 C561.943004,191.276204 536.304808,200.002815 459.380928,200.002815 C396.286895,200.002815 355.666364,195.930396 355.666364,141.243633 C355.666364,86.5615608 396.286895,82.4891422 459.380928,82.4891422 Z M136.944347,0.0927865998 L206.914798,78.7896199 L183.656497,99.5789159 L140.144052,50.6393548 L102.667936,84.137347 L102.622442,84.9538785 C113.947613,83.3451416 124.24091,88.8436433 132.104738,97.6866609 C154.148831,122.476702 143.651043,145.018445 111.13088,174.086834 C70.8607049,210.092247 46.0281756,205.198393 18.6157239,174.366969 C-3.62283384,149.361072 -7.28336705,124.374988 20.4054752,101.173972 L47.4379365,131.576248 C43.3463616,135.234929 39.8548664,139.128747 38.5852388,143.354042 C37.3200807,147.580618 38.0899789,151.929861 42.3017737,156.674191 C53.037878,168.742227 63.6450136,161.979244 84.102888,143.68584 C93.797888,135.026409 115.023397,117.598348 102.756493,103.800909 C94.8939501,94.9534088 82.6855096,101.228117 75.7922221,107.387173 L49.7218601,78.0660948 L136.944347,0.0927865998 Z M343.041715,22.7201916 C381.848245,53.6341331 372.575105,79.052779 324.458175,139.129414 C284.994933,188.405912 256.425651,217.619703 214.014193,183.825724 C171.598078,150.036391 193.842436,115.796472 233.310335,66.5153292 C281.427266,6.43869417 304.239842,-8.19839522 343.041715,22.7201916 Z M264.767285,92.3102379 C226.743219,139.789035 219.756926,150.812143 232.392802,160.878336 C245.028678,170.939883 254.264557,161.714476 292.288623,114.240323 C331.039263,65.8603532 338.197885,56.4491367 324.658449,45.6675802 C311.12367,34.8860237 303.50861,43.9302678 264.767285,92.3102379 Z M462.461329,123.504699 L458.804684,123.504215 C398.015626,123.504215 385.050143,124.95865 385.050143,141.243633 C385.050143,157.37041 397.757612,158.95717 456.995324,158.987293 L462.461329,158.987258 C521.214024,158.969242 532.559225,158.347791 532.559225,141.243633 C532.559225,124.144073 521.214024,123.522714 462.461329,123.504699 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Error500Svg.propTypesMeta = 'exclude';

export default Error500Svg;
